// import { Theme } from '@mui/material/styles';

import { Theme } from "@mui/material";

// ----------------------------------------------------------------------

export default function Typography(theme: Theme) {
  return {
    MuiTypography: {
      styleOverrides: {
        paragraph: {
          marginBottom: theme.spacing(20)
        },
        gutterBottom: {
          marginBottom: theme.spacing(10)
        }
      }
    }
  };
}
